import { Component, OnInit, OnDestroy, Output, EventEmitter, ElementRef, ViewChild, Renderer } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from "@angular/http";

import { AuthService } from "../../services/auth/auth.service";
import { Subscription } from "rxjs/Subscription";
import { environment } from "../../../environments/environment";
import { TitleCasePipe } from '../../pipes/title-case.pipe';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, OnDestroy {
    @ViewChild('navbar') navbar: ElementRef;

    @Output() opacityChanged = new EventEmitter<boolean>();

    dayNight: boolean = false;
    appName: string = "YuDriv Portal";

    onDayNightChange(event: boolean) {
        this.opacityChanged.emit(event);
    }

    loggedIn: boolean = false;
    isTermsOfServiceAccepted: boolean;
    showVehicle: boolean = false;

    constructor(private authService: AuthService, private renderer: Renderer, private http: Http, private titleCase: TitleCasePipe) { }

    onAuthenticationChanged: Subscription;
    onAgreeToTermsOfServiceChanged: Subscription;

    

    ngOnInit() {
        this.getDbVersion();

        this.loggedIn = this.authService.isAuthenticated();
        this.updateWelcomeMessage();
        this.appName = environment.appName;

        this.onAuthenticationChanged = this.authService.authenticationChanged
            .subscribe(
            () => {
                this.loggedIn = this.authService.isAuthenticated();

                if (this.loggedIn) {
                  //this.isTermsOfServiceAccepted = this.authService.getUser().isAgreed;
                  this.showVehicle = true;
                }

                this.updateWelcomeMessage();
              });

        let o: number = +localStorage.getItem('opacity');
        if (o != null) {
            if (o == 1) { o = 0; }
            this.dayNight = o == 0.5;
        }
    }

    onLogout() {
      this.authService.logout()
      this.showVehicle = false;
    }

    ngOnDestroy() {
      this.onAuthenticationChanged.unsubscribe();
    }

    welcomeMessage: string = "";
    private updateWelcomeMessage() {
        this.welcomeMessage = this.authService.getUserName();
        if (this.welcomeMessage != "") {
            this.welcomeMessage = "WELCOME " + this.titleCase.transform(this.welcomeMessage);
        }
    }

    private navbarCollapsed: boolean = true;
    togleMenu() {
        this.navbarCollapsed = !this.navbarCollapsed;

        this.renderer.setElementClass(this.navbar.nativeElement, 'collapse', this.navbarCollapsed);
    }

    dbVersion = "";
    getDbVersion() {
        const qs = environment.apiPath + '/api/lookups/getDbVersion';

        return this.http.get(qs)
            .map(
            (response: Response) => {
                return response.json();
            })
            .subscribe(
            (response: any) => {
                if (response == null || response == "") {
                    this.dbVersion = "v1.0.0.0";
                } else {
                    this.dbVersion = "v" + response;
                }
            },
            (error: Error) => {
                this.dbVersion = "v1.0.0.0";
            });

    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/anon/header.component.ts